// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iMwIq","left":"styles_left__1D6LV"};